type MetaCardProps = {
    icon: React.ReactNode;
    label: string;
    value: string;
    wide?: boolean;
};

const MetaCard = ({ icon, label, value }: MetaCardProps) => {
    return (
        <div className="scenario-meta-card rounded-3 d-flex flex-column w-100 justify-content-between">
            <div className="d-flex align-items-center gap-1 text-secondary">
                <span className="d-inline-flex flex-shrink-0">{icon}</span>
                <span className="scenario-meta-label text-uppercase fw-semibold">
                    {label}
                </span>
            </div>
            <span className="scenario-meta-value fw-semibold text-body text-truncate">{value}</span>
        </div>
    );
};

export default MetaCard;
